// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cf568b73","239":"d720d5f9","453":"92167aee","455":"bd62c0c3"}[chunkId] + ".chunk.js";
};